import styled from 'styled-components';

export const StyledCountdown = styled.div`
  display: flex;
  justify-content: center;
  font: 400 28px/normal ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.fontColor};
  margin-top: 16px;
`;
